import { render, staticRenderFns } from "./walker-sitter.vue?vue&type=template&id=8e624d32&scoped=true&lang=pug"
import script from "./walker-sitter.js?vue&type=script&lang=js&external"
export * from "./walker-sitter.js?vue&type=script&lang=js&external"
import style0 from "./walker-sitter.vue?vue&type=style&index=0&id=8e624d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e624d32",
  null
  
)

export default component.exports